module.exports = __webpack_public_path__ + "static/media/Articles 8.d5e46377.svg";